export default [{
  path: '/vacation-graphic',
  name: 'vacationGraphic',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/vacationGraphic/index')
}]
